// extracted by mini-css-extract-plugin
export var cancelButton = "_pr-5";
export var content = "_pr-3";
export var createButton = "_pr-6";
export var drawerContainer = "_pr-0";
export var footer = "_pr-2";
export var header = "_pr-1";
export var orderFormColumn = "_pr-4";